import '@shoelace-style/shoelace/dist/themes/light.css';

import { Module } from '@rxdi/core';
import SlButton from '@shoelace-style/shoelace/dist/components/button/button';
import SlCard from '@shoelace-style/shoelace/dist/components/card/card';
import SlDetails from '@shoelace-style/shoelace/dist/components/details/details';
import SlIcon from '@shoelace-style/shoelace/dist/components/icon/icon';
import SlIconButton from '@shoelace-style/shoelace/dist/components/icon-button/icon-button';
import SlOption from '@shoelace-style/shoelace/dist/components/option/option';
import SlProgressBar from '@shoelace-style/shoelace/dist/components/progress-bar/progress-bar';
import SlSelect from '@shoelace-style/shoelace/dist/components/select/select';
import SlSwitch from '@shoelace-style/shoelace/dist/components/switch/switch';
import { registerIconLibrary } from '@shoelace-style/shoelace/dist/utilities/icon-library';

registerIconLibrary('default', {
  resolver: (name) => `https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.0.0/dist/assets/icons/${name}.svg`,
});

@Module({
  components: [SlCard, SlIconButton, SlIcon, SlSelect, SlOption, SlDetails, SlButton, SlSwitch, SlProgressBar],
})
export class ShoelaceModule {}
